export var FolderCollectionViewSortColumn;
(function (FolderCollectionViewSortColumn) {
    FolderCollectionViewSortColumn["NAME"] = "name";
    FolderCollectionViewSortColumn["OWNER_NAME"] = "owner_name";
    FolderCollectionViewSortColumn["MODIFY_DATE"] = "user_modify_date";
})(FolderCollectionViewSortColumn || (FolderCollectionViewSortColumn = {}));
